/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Parenttenantusergroupid4Inputs */

const en_entity_parenttenantusergroupid4 = /** @type {(inputs: Entity_Parenttenantusergroupid4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parent Tenant User Group ID`)
};

const de_entity_parenttenantusergroupid4 = /** @type {(inputs: Entity_Parenttenantusergroupid4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eltern-Mandanten-Benutzergruppen-ID`)
};

/**
* | output |
* | --- |
* | "Parent Tenant User Group ID" |
*
* @param {Entity_Parenttenantusergroupid4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_parenttenantusergroupid4 = /** @type {((inputs?: Entity_Parenttenantusergroupid4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Parenttenantusergroupid4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_parenttenantusergroupid4(inputs)
	return de_entity_parenttenantusergroupid4(inputs)
});
export { entity_parenttenantusergroupid4 as "entity_parentTenantUserGroupId" }